import { render, staticRenderFns } from "./QctPrivateProtocal.vue?vue&type=template&id=7faa689e&scoped=true&"
import script from "./QctPrivateProtocal.vue?vue&type=script&lang=js&"
export * from "./QctPrivateProtocal.vue?vue&type=script&lang=js&"
import style0 from "./QctPrivateProtocal.vue?vue&type=style&index=0&id=7faa689e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7faa689e",
  null
  
)

export default component.exports